import { render, staticRenderFns } from "./dialog-alert.mpx?vue&type=template&id=7c87fcd3&isComponent&outputPath=components%2Fdialog-alert3a81462e%2Findex"
import script from "./dialog-alert.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-alert3a81462e%2Findex"
export * from "./dialog-alert.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-alert3a81462e%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports